import React, { useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { USL } from 'lib/alma/alma'
import useVerticalBackUrl from 'components/Navigation/VerticalBackLink/useVerticalBackUrl'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import AppHeaderDesktopExternalNav from './AppHeaderDesktopExternalNav/AppHeaderDesktopExternalNav'
import LanguageNavigation from 'components/Navigation/LanguageNavigation/LanguageNavigation'
import AppHeaderLogo from 'components/AppHeader/AppHeaderLogo/AppHeaderLogo'
import AppHeaderDesktopUserNav from 'components/AppHeader/AppHeaderDesktop/AppHeaderDesktopUserNav/AppHeaderDesktopUserNav'
import AppHeaderInboxNav from 'components/AppHeader/AppHeaderInboxNav/AppHeaderInboxNav'
import { AppHeaderContext } from 'components/AppHeader/AppHeader'
import AppHeaderDesktopVerticalBack from 'components/AppHeader/AppHeaderDesktop/AppHeaderDesktopVerticalBack/AppHeaderDesktopVerticalBack'
import AppHeaderMarketsNav from 'components/AppHeader/AppHeaderMarketsNav/AppHeaderMarketsNav'
import Link from 'components/Link'
import AuthLoginButton from 'components/Auth/AuthLoginButton/AuthLoginButton'
import AuthLogoutButton from 'components/Auth/AuthLogoutButton/AuthLogoutButton'
import { AuthContext } from 'components/Auth/Auth'
import LoadingIndicator from 'components/LoadingIndicator'

import './app-header-desktop.pcss'

const AppHeaderDesktop = ({ className }) => {
    const history = useHistory()
    const location = useLocation()
    const auth = useContext(AuthContext)
    const { loggedIn, currentUserLoading } = useContext(AppHeaderContext)
    const verticalBack = useVerticalBackUrl()

    const { t, i18n } = useTranslation('common')

    return (
        <header className={classNames('app-header-desktop', className)}>
            <div className="app-header-desktop__top">
                <div className="app-header-desktop__top-inner">
                    <AppHeaderDesktopExternalNav t={t} />
                    <LanguageNavigation history={history} location={location} />
                </div>
            </div>
            <div className="app-header-desktop__bottom">
                <AppHeaderDesktopVerticalBack />
                {!verticalBack && (
                    <div className="app-header-desktop__branding">
                        <AppHeaderLogo title={t('common:appTitle')} />
                    </div>
                )}
                <div className="app-header-desktop__left">
                    {(currentUserLoading || auth.almaLoading) ? (
                        <LoadingIndicator type="plain" loaderType="header" />
                    ) : (
                        loggedIn ? (
                            <div className="app-header-desktop__user-items">
                                <Link
                                    exact
                                    to={`${getLocale(i18n.language) || '/'}`}
                                    title={t('common:navigation.myVehicles')}
                                    trackName="myVehicles"
                                >
                                    {t('common:navigation.myVehicles')}
                                </Link>
                                <AppHeaderInboxNav />
                                <AppHeaderMarketsNav />
                            </div>
                        ) : (
                            <div className="app-header-desktop__user-items">
                                <Link
                                    exact
                                    to={`${getLocale(i18n.language) || '/'}`}
                                    title={t('common:navigation.myVehicles')}
                                    trackName="myVehicles"
                                >
                                    {t('common:navigation.myVehicles')}
                                </Link>
                                <Link
                                    to={`${getLocale(i18n.language)}/fiksut-kaupat`}
                                    title={t('common:navigation.markets')}
                                    trackName="bosList"
                                >
                                    {t('common:navigation.markets')}
                                </Link>
                            </div>
                        )
                    )}
                </div>
                <div className="app-header-desktop__right">
                    {(currentUserLoading || auth.almaLoading) ? (
                        <LoadingIndicator type="plain" loaderType="header" />
                    ) : (
                        loggedIn ? (
                            <div className="app-header-desktop__user-context">
                                <AppHeaderDesktopUserNav />
                            </div>
                        ) : (
                            <div className="app-header-desktop__user-login">
                                {auth.almaAuthData?.user ? (
                                    <AuthLogoutButton />
                                ) : (
                                    <AuthLoginButton
                                        userSourceLabeling={{
                                            source: USL.SOURCE.navigation_topmenu_login,
                                            type: USL.TYPE.permanent,
                                        }}
                                    >
                                        {t('common:login.cta.login')}
                                    </AuthLoginButton>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
        </header>
    )
}

AppHeaderDesktop.propTypes = {
    className: PropTypes.string.isRequired,
}

export default AppHeaderDesktop
